module.exports = __webpack_public_path__ + "Flama-Ultralight.woff?d4a23777473f696066665bbe39fc3f3c";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-Ultralight.woff
// module id = 921
// module chunks = 0